export enum RouteState {
  SILENT_REPLACE = '__silentReplace__',
  SILENT_PUSH = '__silentPush__',
  FORCE_LOAD = '__forceLoad__'
}

export const GLOBAL_SCROLL_ELEMENT_ATTR = 'data-global-scroll'
